const roomKeyDashboardDummy = {
  success: true,
  message: "Dashboard statistics fetched successfully.",
  requestId: "dashboard-room-key-001",
  data: {
    summary: {
      todayArrivals: {
        total: 18,
        changePercentage: 12,
        comparedTo: "vs yesterday",
      },
      todayDepartures: {
        total: 11,
        changePercentage: -8,
        comparedTo: "vs yesterday",
      },
      activeStays: {
        total: 64,
        changePercentage: 6,
        comparedTo: "vs yesterday",
      },
      dueRequests: {
        total: 14,
        pending: 9,
        inProgress: 5,
        changePercentage: 18,
        comparedTo: "vs yesterday",
      },
    },

    occupancy: {
      occupiedRooms: 64,
      totalRooms: 80,
      availableRooms: 16,
      percentage: 80,
    },

    occupancyTrends: {
      selectedFilter: "monthly",
      filters: ["weekly", "monthly", "yearly"],

      weekly: {
        categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        occupancy: [62, 65, 64, 68, 72, 80, 75],
      },

      monthly: {
        categories: Array.from({ length: 30 }, (_, i) => `${i + 1}`),
        occupancy: [
          58, 59, 60, 62, 64, 63, 65, 67, 69, 70, 72, 73, 74, 76, 78, 80, 82, 84, 83, 81, 79, 78,
          80, 82, 83, 85, 87, 86, 88, 89,
        ],
      },

      yearly: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
        occupancy: [58, 60, 64, 69, 72, 78, 84, 82, 76, 79],
      },
    },
    returningGuests: {
      total: 7,
      todayArrivalsTotal: 18,
      percentageOfArrivals: 8.9,
    },

    preferenceCompletion: {
      completedForms: 52,
      totalEligibleForms: 64,
      completionPercentage: 81.3,
      incompleteForms: 12,
    },

    reservationTrends: {
      selectedFilter: "monthly",
      filters: ["weekly", "monthly", "yearly"],

      weekly: {
        categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        reservations: [9, 12, 11, 15, 19, 24, 17],
        paid: [7, 9, 9, 12, 16, 21, 14],
        unpaid: [2, 3, 2, 3, 3, 3, 3],
      },

      monthly: {
        categories: Array.from({ length: 30 }, (_, i) => `${i + 1}`), // 1–30
        reservations: [
          4, 5, 6, 7, 8, 6, 7, 9, 10, 12, 14, 13, 15, 17, 18, 20, 22, 24, 23, 21, 19, 18, 20, 22,
          24, 26, 28, 27, 29, 30,
        ],
        paid: [
          3, 4, 5, 6, 7, 5, 6, 8, 9, 10, 12, 11, 13, 14, 15, 17, 18, 20, 19, 18, 17, 16, 18, 19, 21,
          23, 24, 23, 25, 26,
        ],
        unpaid: [
          1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 4, 4, 4, 3, 2, 2, 2, 3, 3, 3, 4, 4, 4, 4,
        ],
      },

      yearly: {
        categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
        reservations: [120, 132, 141, 156, 162, 170, 184, 176, 168, 181],
        paid: [96, 108, 116, 126, 131, 141, 153, 146, 137, 149],
        unpaid: [24, 24, 25, 30, 31, 29, 31, 30, 31, 32],
      },
    },

    guestInsights: {
      totalUniqueGuests: 1486,
      topGuest: {
        guestId: "guest_001",
        name: "John Carter",
        stays: 14,
      },
      averageStayDurationNights: 3.8,
      returningGuestRatio: 34,
    },

    preferenceInsights: {
      completedProfiles: 52,
      incompleteProfiles: 12,
      archetype: {
        name: "Comfort-focused business traveler",
        percentage: 42,
      },
      dietaryPreferenceTrends: [
        { label: "No restrictions", value: 28 },
        { label: "Vegetarian", value: 11 },
        { label: "Halal", value: 9 },
        { label: "Vegan", value: 4 },
        { label: "Gluten-free", value: 3 },
      ],
      pillowTrends: [
        { label: "Medium", value: 22 },
        { label: "Soft", value: 17 },
        { label: "Firm", value: 13 },
      ],
      temperatureTrends: [
        { label: "Cool", value: 25 },
        { label: "Moderate", value: 19 },
        { label: "Warm", value: 8 },
      ],
      culinaryPreferenceTrends: [
        { label: "Local Cuisine", value: 34 },
        { label: "Healthy Dining", value: 24 },
        { label: "Fine Dining", value: 20 },
        { label: "Comfort Food", value: 14 },
        { label: "Vegan Focus", value: 8 },
      ],
      eveningPreferenceTrends: [
        { label: "Quiet Relaxation", value: 41 },
        { label: "Rooftop Drinks", value: 27 },
        { label: "Nightlife", value: 18 },
        { label: "Spa Evening", value: 14 },
      ],

      neighborhoodPreferenceTrends: [
        { label: "Food Scene", value: 38 },
        { label: "Shopping", value: 26 },
        { label: "Culture", value: 19 },
        { label: "Nature", value: 11 },
        { label: "Nightlife", value: 6 },
      ],
    },

    operationsTimeline: [
      {
        type: "arrival",
        title: "18 arrivals scheduled today",
        dateTime: "Today • 3:00 PM",
      },
      {
        type: "departure",
        title: "11 departures expected today",
        dateTime: "Today • 11:00 AM",
      },
      {
        type: "request",
        title: "14 guest requests due today",
        dateTime: "Today • Live",
      },
      {
        type: "preferences",
        title: "52 preference forms completed",
        dateTime: "Updated 15 min ago",
      },
      {
        type: "occupancy",
        title: "Occupancy holding at 80%",
        dateTime: "Today",
      },
      {
        type: "returning",
        title: "7 returning guests arriving today",
        dateTime: "Today",
      },
    ],
  },
};

export default roomKeyDashboardDummy;
